export default "__VITE_ASSET__D8FyywnF__"